import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('files');

export const check = () => useBasicAuth.checkToken();

export const uploadFileGeologia = (formData) => 
  axios.post(urlAPI + "/shapesGeologia", formData, environment.HEADER_FORM_DATA)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const uploadFileGeologiaEstado = (formData) => 
  axios.post(urlAPI + "/shapesGeologiaEstado", formData, environment.HEADER_FORM_DATA)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const uploadFileGeologiaBrasil = (formData) => 
  axios.post(urlAPI + "/shapesGeologiaBrasil", formData, environment.HEADER_FORM_DATA)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const uploadFileRequerimento = (formData) => 
  axios.post(urlAPI + "/shapesRequerimento", formData, environment.HEADER_FORM_DATA)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const uploadFileGeologiaCidadeArea = (formData) => 
  axios.post(urlAPI + "/shapesGeologiaCidadeArea", formData, environment.HEADER_FORM_DATA)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const uploadFileGeologiaEstadoArea = (formData) => 
  axios.post(urlAPI + "/shapesGeologiaEstadoArea", formData, environment.HEADER_FORM_DATA)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const uploadFileGeologiaCavernas = (formData) => 
  axios.post(urlAPI + "/shapesGeologiaCavernas", formData, environment.HEADER_FORM_DATA)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const uploadFileGeologiaProtecaoIntegral = (formData) => 
  axios.post(urlAPI + "/shapesGeologiaProtecaoIntegral", formData, environment.HEADER_FORM_DATA)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const uploadFileGeologiaQuilombolas = (formData) => 
  axios.post(urlAPI + "/shapesGeologiaQuilombolas", formData, environment.HEADER_FORM_DATA)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const uploadFileGeologiaSitiosArqueologicos = (formData) => 
  axios.post(urlAPI + "/shapesGeologiaSitiosArqueologicos", formData, environment.HEADER_FORM_DATA)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const uploadFileGeologiaTerrasIndigenas = (formData) => 
  axios.post(urlAPI + "/shapesGeologiaTerrasIndigenas", formData, environment.HEADER_FORM_DATA)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const uploadFileGeologiaUsoSustentavel = (formData) => 
  axios.post(urlAPI + "/shapesGeologiaUsoSustentavel", formData, environment.HEADER_FORM_DATA)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  
  
export const getFileNames = (path) => 
  axios.get(urlAPI + "/fileNames/" + path, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });